var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "header",
        {
          class: {
            scrolled: _vm.isScrolled && !_vm.selectedMenuId,
            "menu-open": _vm.showMobileMenu,
          },
          attrs: { id: "mobile-header" },
        },
        [
          _c("div", { staticClass: "header__body" }, [
            _c("div", { staticClass: "header__animation" }, [
              _c("a", { staticClass: "brand", attrs: { href: _vm.homeUrl } }, [
                _c(
                  "div",
                  { attrs: { id: "lottie-animation" } },
                  [
                    _c("lottie-player", {
                      attrs: {
                        src: _vm.brandLottieUrl,
                        background: "transparent",
                        speed: "1",
                        loop: "",
                        autoplay: "",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "header__brand" }),
            _vm._v(" "),
            _c("div", { staticClass: "header__body__grouplogo" }, [
              _c("a", { staticClass: "brand", attrs: { href: _vm.homeUrl } }, [
                _c("img", {
                  attrs: { src: _vm.groupImageUrl, alt: _vm.brandTitle },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "menu-toggle",
                class: { "menu-toggle--close": _vm.showMobileMenu },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.didSelectToggleMobileMenu()
                  },
                },
              },
              [_c("span", { staticClass: "sr-only" }, [_vm._v("Menu")])]
            ),
          ]),
          _vm._v(" "),
          _vm.phoneNumber
            ? _c("div", { staticClass: "header__phone" }, [
                _c(
                  "a",
                  {
                    staticClass: "header__body__contact__phone",
                    attrs: { href: _vm.phoneUrl },
                  },
                  [_vm._v(_vm._s(_vm.phoneNumber))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "header__quick_quote" },
                  [
                    _c("dropdown-links", {
                      attrs: {
                        "default-label": "Quick Quote",
                        "input-class": "button button--small",
                        links: _vm.quickQuoteLinks,
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.showMobileMenu
            ? _c("mobile-menu", {
                attrs: {
                  "menu-data": _vm.primaryMenu,
                  "secondary-menu-data": _vm.topMenu,
                  "current-id": _vm.currentId,
                  "phone-url": _vm.phoneUrl,
                  "phone-number": "" + _vm.phoneNumber + "",
                  "alt-phone-url": _vm.altPhoneUrl,
                  "alt-phone-number": "" + _vm.altPhoneNumber + "",
                  "search-action": _vm.searchAction,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/MobileHeader.vue